import styled from "styled-components";
import Color from "../../constants/Color";

const RedStrikeThrough = styled.span`
    color: ${Color.STATUS_CRITICAL};
`;

export default RedStrikeThrough;
